import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { PrimeTemplate } from "primeng-v17/api";
import { CardModule } from "primeng-v17/card";
import { InputTextareaModule } from "primeng-v17/inputtextarea";
import { RatingModule } from "primeng-v17/rating";
import { EscapeButtonDirective } from "../../../shared/directives/escape-button.directive";
import { FormElementMapModule } from "../../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../../shared/test-id/test-id.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiUserFeedbackEditDialogComponent } from "./new-ui-user-feedback-edit-dialog.component";

@Component({
  selector: "app-user-feedback-edit-dialog",
  templateUrl: "./user-feedback-edit-dialog.component.html",
  imports: [
    TranslateDirective,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    RatingModule,
    FormElementMapModule,
    TestIdDirective,
    InputTextareaModule,
    PrimeTemplate,
    Button,
    EscapeButtonDirective,
  ],
})
export class UserFeedbackEditDialogComponent extends NewUiUserFeedbackEditDialogComponent {}
